import { useState } from 'react'

/**
 * What the agent is doing, in plain words.
 *
 * A spinner says "wait". This says "I am reading six observations about
 * catching" — which is the difference between opaque and trustworthy.
 */
const VERBS: Record<string, string> = {
  write_artifact: 'Writing',
  read_artifacts: 'Reading',
  search: 'Searching',
  remember: 'Remembering',
  capture: 'Logging',
  schedule: 'Scheduling',
  analyze_image: 'Looking at',
  read_rubric: 'Reading the rubric',
  update_rubric: 'Updating the rubric',
  read_plan: 'Reading the plan',
  write_plan: 'Writing the plan',
  read_reviews: 'Reading the check-ins',
  write_review: 'Writing the review',
}

function describe(call: any): string {
  const verb = VERBS[call.name] ?? call.name
  const input = call.input ?? {}
  if (call.name === 'write_artifact') return `${verb} ${input.kind ?? 'artifact'}: ${input.title ?? ''}`
  if (call.name === 'read_artifacts') return `${verb} ${input.kind ?? 'artifacts'}`
  if (call.name === 'search') return `${verb} for "${input.query ?? ''}"`
  if (call.name === 'remember') return `${verb}: ${input.statement ?? ''}`
  if (call.name === 'analyze_image') return `${verb} the drawing`
  if (call.name === 'update_rubric') {
    const n = call.output?.states ?? call.input?.states?.length
    return n ? `${verb} — ${n} skill${n === 1 ? '' : 's'} moved` : verb
  }
  if (call.name === 'write_plan') {
    const n = call.output?.blocks ?? 0
    return n ? `${verb} — ${n} blocks` : verb
  }
  return verb
}

export function ToolActivity({ calls }: { calls: any[] }) {
  const [open, setOpen] = useState(false)
  const running = calls.some((c) => c.status === 'running')

  return (
    <div className={`tools${running ? ' is-running' : ''}`}>
      <button className="tools-head" onClick={() => setOpen((v) => !v)} aria-expanded={open}>
        <span className="tools-dot" aria-hidden="true" />
        <span className="tools-summary">
          {calls.map(describe).slice(0, 2).join(' · ')}
          {calls.length > 2 ? ` +${calls.length - 2}` : ''}
        </span>
      </button>
      {open && (
        <ul className="tools-detail">
          {calls.map((c, i) => (
            <li key={c.id ?? i} className={`tools-item is-${c.status ?? 'complete'}`}>
              <span className="tools-item-name">{describe(c)}</span>
              {c.error && <span className="tools-item-error">{c.error}</span>}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
